// import type { ResolvedConfig } from "@/types/config.types";
import { getConfig } from "@/config";
import { logsService } from "../services/logs/logs.service";
import type { LogEntry } from "../services/logs/logs.types";

const kv = (
	obj: Record<string, unknown> = {},
): { key: string; value: string }[] =>
	Object.entries(obj).map(([key, value]) => ({
		key,
		value: String(value),
	}));

export const logApp = async ({
	level,
	message,
}: {
	level: LogEntry["level"];
	message: string;
}) => {
	const config = getConfig();
	const SOURCE = "web-ui";
	const SERVICE = config?.app?.name ?? "unknown";
	// const APP_VERSION = config?.app?.version ?? "unknown";
	const ENV = config?.app?.environment ?? "unknown";

	const payload: LogEntry = {
		message,
		source: SOURCE,
		serviceName: SERVICE,
		level,
		values: kv({
			// ...context,
			env: ENV,
			// release: APP_VERSION,
		}),
	};

	try {
		// console.log("🪵 Logging app 1", payload);
		await logsService.postLog(payload);
	} catch {
		console.error("Failed to log app", payload);
	}
};
